import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { loginRequest, msalInstance } from '@/authConfig';
import { installFetchPatch } from '@/lib/fetch-patch';
import '@/index.css';

/**
 * Gate-at-init (task [3.1]) — mirrors Fireball.Ui's top-level-await auth gate,
 * which email-hub deferred out of authConfig.ts into the shell. MSAL is
 * initialized and its redirect promise resolved BEFORE any React render; an
 * unauthenticated visitor is bounced to loginRedirect and no page body ever
 * mounts (the gate lives here, not in a per-route wrapper). Once an account is
 * active, installFetchPatch() wires the bearer/antiforgery fetch layer, then
 * the routed tree renders.
 */
async function bootstrap(): Promise<void> {
	await msalInstance.initialize();
	await msalInstance.handleRedirectPromise();

	const accounts = msalInstance.getAllAccounts();
	if (accounts.length === 0) {
		await msalInstance.loginRedirect(loginRequest);
		return; // navigating away to the IdP — never render a page body
	}

	msalInstance.setActiveAccount(accounts[0]);
	installFetchPatch();

	createRoot(document.getElementById('root')!).render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}

void bootstrap();
